<h2 mat-dialog-title>Change Password</h2>

<mat-dialog-content [formGroup]="passwordForm">
  <div class="form-field-container">
    <mat-form-field class="full-width">
      <mat-label>Current Password</mat-label>
      <input
        matInput
        formControlName="password"
        type="password"
        autocomplete="current-password"
        aria-describedby="current-password-error"
      />
      @if (passwordForm.controls.password.hasError('required')) {
        <mat-error id="current-password-error">Current password is required</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="form-field-container">
    <mat-form-field class="full-width">
      <mat-label>New Password</mat-label>
      <input
        matInput
        formControlName="newPassword"
        type="password"
        autocomplete="new-password"
        aria-describedby="new-password-error"
      />
      @if (passwordForm.controls.newPassword.invalid) {
        <mat-error id="new-password-error"
          >Password is required and must be 6 characters or more, contain upper and lower case
          letters and numbers</mat-error
        >
      }
    </mat-form-field>
  </div>

  <div class="form-field-container">
    <mat-form-field class="full-width">
      <mat-label>Confirm New Password</mat-label>
      <input
        matInput
        formControlName="newPassword2"
        type="password"
        autocomplete="new-password"
        aria-describedby="confirm-password-error"
      />
      @if (passwordForm.controls.newPassword2.invalid) {
        <mat-error id="confirm-password-error"
          >Password is required and must be 6 characters or more, contain upper and lower case
          letters and numbers</mat-error
        >
      }
    </mat-form-field>
  </div>

  @if (passwordsMismatch) {
    <div class="password-mismatch-error" role="alert" aria-live="polite">
      Passwords do not match.
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton="filled" (click)="changePassword()" [disabled]="!passwordForm.valid">
    Change Password
  </button>
  <button matButton="outlined" [mat-dialog-close]="false">Cancel</button>
</mat-dialog-actions>
